let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;


  
  //Scrolling Banner test
  const c_scrollingBanner = window.igData?.user.getTestGroup(
    "5464b04f-3945-456e-9434-95d42fdf79bd"
  );
  if (c_scrollingBanner?.name === "Var A") {
    document.body.classList.add("c-scrolling-banner-varA");
  }

  //Testimonial in cart drawer
  const c_cartdrawer_testimonial = window.igData?.user.getTestGroup(
    "b4a4773a-f1e4-47da-a5fe-5f228c6ef341"
  );

if (c_cartdrawer_testimonial?.name === 'Var A') {
  document.body.classList.add('c-testimonial-cartdrawer-test');
}

}

// Check if DOM is already loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    domLoaded = true;
    handleExperiments();
  });
} else {
  domLoaded = true;
  handleExperiments();
}

// Check for ig:ready event
if (window.igData) {
  igReady = true;
  handleExperiments();
} else {
  window.addEventListener("ig:ready", () => {
    igReady = true;
    handleExperiments();
  });
}